import React from 'react';
import { connect } from 'react-redux';

import { selectLayoutType } from '../selectors/LayoutTypeSelector';
import { NavLocationSelectors } from '../selectors/NavigationStateSelectors';
import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { LeftNav, LeftNavProps } from './LeftNav';

const mapStateToProps: MapStateToProps<LeftNavProps> = (state: AppState) => ({
  isInVizViewerArea: NavLocationSelectors.inVizViewerArea(state),
  layoutType: selectLayoutType(state)
});

export const ConnectedLeftNav: React.ComponentClass =
  connect(mapStateToProps)(LeftNav);
